import React, {useCallback} from 'react';
import Button, {ButtonProps} from '@material-ui/core/Button';
import theme from '../../theme';
import MenuItemAnchor, {MenuItemAnchorProps} from './MenuItemAnchor';
import gettext from '../../utils/django/gettext';
import {AuthModalState} from '../AuthModal';

function isHidden(user: User | undefined) {
    return !user || user.isAuthenticated;
}

type ToolbarProps = ButtonProps & {
    user: User | undefined;
    setAuthModal: SetState<AuthModalState>;
};

function Toolbar({style, user, setAuthModal, ...props}: ToolbarProps) {
    const openAuthModal = useCallback(() => {
        if (
            window.location.pathname === '/register/' ||
            window.location.pathname === '/'
        ) {
            window.location.href = `/login/${window.location.search}`;
        } else {
            setAuthModal({form: 'login', analyticsContext: 'header login'});
        }
    }, [setAuthModal]);

    if (window.location.pathname === '/login/' || isHidden(user)) return null;

    return (
        <>
            <Button
                {...props}
                onClick={openAuthModal}
                style={{...style, color: theme.palette.primary.main}}
                color='primary'
                variant='outlined'
            >
                {gettext('Log In')}
            </Button>
        </>
    );
}

const HamburgerMenu = React.forwardRef(
    // eslint-disable-next-line prefer-arrow-callback
    function HamburgerMenuInner(
        props: MenuItemAnchorProps & {user: User | undefined},
        ref: React.Ref<any>
    ) {
        if (isHidden(props.user)) return null;

        return (
            <MenuItemAnchor
                ref={ref as any}
                {...props}
                href={`/login/?next=${window.location.pathname}`}
            >
                {gettext('Log In')}
            </MenuItemAnchor>
        );
    }
);

export default {Toolbar, HamburgerMenu};
